import { render, staticRenderFns } from "./SequenceComponent.vue?vue&type=template&id=180bf380&scoped=true&"
import script from "./SequenceComponent.vue?vue&type=script&lang=js&"
export * from "./SequenceComponent.vue?vue&type=script&lang=js&"
import style0 from "./SequenceComponent.vue?vue&type=style&index=0&id=180bf380&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180bf380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chenzihao/code/workspace/arkui-bus/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180bf380')) {
      api.createRecord('180bf380', component.options)
    } else {
      api.reload('180bf380', component.options)
    }
    module.hot.accept("./SequenceComponent.vue?vue&type=template&id=180bf380&scoped=true&", function () {
      api.rerender('180bf380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common-table-by-ag-grid/renderComponents/SequenceComponent.vue"
export default component.exports